import {isRightToken} from './Common'

function getCookieDomain(host) {
    if (!host || !host.replace) {
        return undefined
    }
    host = host.replace(/:\d+$/, '')
    if (host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
        return undefined
    }
    const list = host.split('.')
    if (list.length < 2) {
        return undefined
    }
    return `.${list[list.length - 2]}.${list[list.length - 1]}`
}

/**
 * Token Cookie 写入/删除选项（localhost、IP 不设 domain，避免浏览器拒写 Cookie）
 */
export function getTokenCookieOptions(extra = {}) {
    const host =
        typeof window !== 'undefined' && window.location ? window.location.hostname.replace(/:\d+$/, '') : ''
    const options = {expires: 365, ...extra}
    const domain = getCookieDomain(host)
    if (domain) {
        options.domain = domain
    }
    return options
}

/**
 * 刷新/启动时合并 Cookie、localStorage、URL 中的 token
 */
export function resolveAuthToken(cookieToken, storageToken, searchToken) {
    if (searchToken && isRightToken(searchToken)) {
        return searchToken
    }
    const cookieValid = isRightToken(cookieToken)
    const storageValid = isRightToken(storageToken)
    if (cookieValid && storageValid && cookieToken !== storageToken) {
        return cookieToken
    }
    if (cookieValid) {
        return cookieToken
    }
    if (storageValid) {
        return storageToken
    }
    if (cookieToken === '0' || cookieToken === 0 || storageToken === '0' || storageToken === 0) {
        return 0
    }
    return 0
}
